import { createFileRoute } from '@tanstack/react-router';
import { OrganizationDetailsContainer } from 'src/containers/organization-details/organization-details-container';

export const Route = createFileRoute(
  '/_layout/tenant/organization-details/_layout',
)({
  component: OrganizationDetailsContainer,
});
